module.exports = __webpack_public_path__ + "img/edit2_p.d9e339da.svg";